import React, { useContext, useRef, useState } from "react";
import { useParams, useNavigate } from "react-router";
import LoadingBar from "react-top-loading-bar";
import { toastError, toastWarning } from "../../../../shared/helpers";
import { demoContext } from "../../../../shared/store/contexts";

import PageHero from "../../../molecules/PageHero";
import CreateReferralFormSuccessModal from "../../../organisms/CreateReferralFormSuccessModal";
import ReferralCopyCodeModal from "../../../organisms/ReferralCopyCodeModal";
import ReferralFormShareLinkModal from "../../../organisms/ReferralFormShareLinkModal";
import { FormOne, FormPreview, FormTwo } from "../../../templates/AddReferralForms";

const AddReferralFormPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const loader = useRef(null);

  const [step, setStep] = useState(1);
  const [fields, setFields] = useState({});
  const [formInfo, setFormInfo] = useState({});

  const [modalStates, setModalStates] = useState({
    shareLink: false,
    copyCode: false,
    createFormSuccess: false,
  });

  const updateFields = (data) => setFields({ ...fields, ...data });

  const discardData = () => {
    navigate(`/dashboard/organization/${id}/referral-forms`);
  };

  const onSubmit = (mode = "publish") => {
    toastWarning("Cannot perform this action on Demo mode");
  };

  return (
    <main className="flex flex-col w-full relative">
      <LoadingBar height={2} color="#00AF72" ref={loader} />
      <PageHero
        className="organization-container"
        title="Add Custom Referral Form"
        goBackText="Back to  Referrals"
        back
      />

      {step === 1 && (
        <FormOne
          fields={fields}
          updateFields={updateFields}
          discard={discardData}
          saveToDraft={(data) => onSubmit(data, "draft")}
          changeStep={(step) => setStep(step)}
        />
      )}
      {step === 2 && (
        <FormTwo
          fields={fields}
          updateFields={updateFields}
          discard={discardData}
          saveToDraft={(data) => onSubmit(data, "draft")}
          changeStep={(step) => setStep(step)}
        />
      )}
      {step === 3 && (
        <FormPreview
          fields={fields}
          updateFields={updateFields}
          discard={discardData}
          saveToDraft={(data) => onSubmit(data, "draft")}
          changeStep={(step) => setStep(step)}
          submitForm={() => onSubmit("publish")}
        />
      )}
      {modalStates?.createFormSuccess && (
        <CreateReferralFormSuccessModal
          closeModal={() => {
            window.location = `/dashboard/organization/${id}/referral-forms/`;
          }}
          showShareLinkModal={() => {
            setModalStates({ ...modalStates, shareLink: true });
          }}
          showCodeModal={() => {
            setModalStates({ ...modalStates, copyCode: true });
          }}
        />
      )}
      {modalStates?.shareLink && (
        <ReferralFormShareLinkModal
          closeModal={() => setModalStates({ ...modalStates, shareLink: false })}
          link={formInfo?.url}
        />
      )}
      {modalStates?.copyCode && (
        <ReferralCopyCodeModal
          closeModal={() => setModalStates({ ...modalStates, copyCode: false })}
          link={formInfo?.url}
        />
      )}
    </main>
  );
};

export default AddReferralFormPage;
